import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/_services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {

  returnUrl: string = '/';

  constructor(private router: Router,
    private authenticationService: AuthenticationService) {
 
  }

  ngOnInit() {
    //Valida si ya Existe una sesion activa y en tal caso redirecciona al Home
    if (this.authenticationService.currentUserValue) {
      if (this.authenticationService.currentUserValue.firstEntryDate == null) {
        this.returnUrl = '/login/first-time';
      }
      //Valida si la contraseñaes temporal y no es el primer ingreso  , recupero contraseña o le generaron contraseña
      if ((this.authenticationService.currentUserValue.firstEntryDate && this.authenticationService.currentUserValue.temporalPassword) || this.authenticationService.currentUserValue.expiredPassword) {
        this.returnUrl = '/login/change-password';
      }
      return this.router.navigate([this.returnUrl]);
    };
  };

  logIt(event) {
    console.log('Animation done, $event: ', event);
  }
}
